<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Buttons from './Buttons.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'buttons': Buttons,
		},
		data () {
			return {
				data: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reloadData() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/agreements/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/views/Show.vue